// extracted by mini-css-extract-plugin
export default {"background":"_base-hero-background_background_W4fq9","image":"_base-hero-background_image_H2c9b"};